module.exports = __webpack_public_path__ + "static/media/DKBSlogo_new.fe182ef3.png";